module.exports = __webpack_public_path__ + "static/media/instagram-white.01e0ca2a.svg";